import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable, of, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
@Component({
  selector: "app-select",
  templateUrl: "./app-select.component.html",
  styleUrls: ["./app-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectComponent),
      multi: true,
    },
  ],
})
export class AppSelectComponent implements OnInit, ControlValueAccessor {
  @Input() option$: Observable<any[]>;
  @Input() multiple: boolean;
  @Input() bindLable: string;
  @Input() bindValue: string;
  @Input() name: string;
  @Input() placeHolder: string;
  @Input() searchText: string;
  @Input() disabled: boolean;
  isDisabled: boolean;
  searchInput$ = new Subject<string>();
  @Output() change = new EventEmitter<any>();
  @Output() onSearch = new EventEmitter<any>();

  innerValue: any;

  private onTouched: () => void;
  private onChange: (_: any) => void;

  constructor(private cdf: ChangeDetectorRef) {
    this.isDisabled = false;
  }

  //get accessor
  get value(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChange(v);
    }
  }

  ngOnInit(): void {
    this.searchInput$
      .pipe(distinctUntilChanged(), debounceTime(200))
      .subscribe((searchTerm) => this.onSearch.emit(searchTerm));
  }

  valueChanged(val) {
    this.onChange(val);
    this.onTouched();
  }

  writeValue(obj: any): void {
    if (obj !== this.innerValue) {
      this.innerValue = obj;
      this.value = obj;
      this.cdf.markForCheck();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  trackByFn(item: any) {
    return item.id;
  }
}
